import React, { useMemo } from "react";

import Form, { ButtonItem, GroupItem, SimpleItem } from "devextreme-react/form";
import "devextreme-react/text-area";
import notify from "devextreme/ui/notify";
import dxTextArea from "devextreme/ui/text_area";
import { useTranslation } from "react-i18next";

import {
  canGenerateTemporaryToken,
  generateTempToken,
  selectCurrentGroupsTreeList,
  selectedGroupData,
  useAppDispatch,
  useAppSelector,
} from "@app/state";
import { selectMaLinkByGroupId } from "@app/state/units";
import { commonStyle } from "@app/style/commonForms";

import "./orgforms.scss";

const bxHeight = 100;

export function FormRemoteKey({ readOnly = false }: { readOnly?: boolean }) {
  const { t } = useTranslation();
  const maliRef = React.useRef<dxTextArea>(null);
  const dispatch = useAppDispatch();
  const selectedTree = useAppSelector(selectCurrentGroupsTreeList);
  const theSelectedOrgData = useAppSelector((s) =>
    selectedGroupData(s, selectedTree?.id)
  );
  const canGenerate = canGenerateTemporaryToken(
    selectedTree,
    theSelectedOrgData
  );

  const theUrl = useAppSelector((s) =>
    selectMaLinkByGroupId(s, {
      GROUPID: canGenerate ? theSelectedOrgData.GROUPID : null,
    })
  );
  // here the url is {data:{code:"xxxxx"}
  const theLink = useMemo(() => {
    if (!theUrl?.CODE) return "";
    const url = `${window.location.origin.replace(
      "3000",
      "8033"
    )}/rest/api/remoteworks/auto-login/${theUrl.CODE}`;
    return url;
  }, [theUrl]);

  if (!canGenerate) return null;

  const copyToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        notify(
          {
            message: t("copied_to_clipboard"),
            width: document.getElementById("idmalink")?.clientWidth || 300,
            height: bxHeight,
            position: {
              my: "center top",
              at: "center top",
              offset: "0 0",
              of: "#idmalink",
            },
          },
          "success",
          1000
        );
      })
      .catch((err) => {
        notify({ message: "Could not copy text: " + err }, "error", 3000);
      });
  };
  return (
    <Form
      id={"formRemoteKey"}
      formData={{
        RKEY: theLink,
      }}
      readOnly={readOnly}
      showValidationSummary={true}
      labelLocation={"top"}
      style={{ width: "100%" }}
    >
      <GroupItem colCount={4} caption={t("Remote Key")} visible={true}>
        <SimpleItem
          dataField={"RKEY"}
          colSpan={3}
          label={{ text: t("Remote url") }}
          editorType={"dxTextArea"}
          editorOptions={{
            ref: maliRef,
            ...commonStyle({
              elementclass: "filledunderline dxx-rounded8",
              elementAttr: { id: "idmalink" },
            }),
            readOnly: true,
            height: bxHeight,
            onFocus: (e: any) => e.component.selectText(), // This will highlight the text when textarea is focused
          }}
        />
        <GroupItem colCount={1}>
          <ButtonItem
            colSpan={1}
            horizontalAlignment={"right"}
            buttonOptions={{
              width: 120,
              text: t("Generate"),
              type: "default",
              onClick: async () => {
                dispatch(generateTempToken());
              },
            }}
          />

          <ButtonItem
            colSpan={1}
            horizontalAlignment={"right"}
            buttonOptions={{
              width: 120,
              text: t("Copy"),
              type: "default",
              onClick: (e: any) => {
                if (theUrl?.CODE) {
                  copyToClipboard(theLink);
                }
              },
            }}
          />
        </GroupItem>
      </GroupItem>
    </Form>
  );
}
